<template>
  <div class="shop-navigation">
    <ButtonComponent
      v-if="hasPrev"
      :label="$t('prev')"
      icon-placement="left"
      :icon="['fal', 'angle-left']"
      @click="$emit('prev')"
    />
    <ButtonComponent
      v-if="hasNext"
      :label="hasPrev ? $t('next') : $t('start')"
      :theme="'primary'"
      :icon="['fal', 'angle-right']"
      @click="$emit('next')"
    />

    <slot v-if="!hasNext" name="action" />
  </div>
</template>

<script>
export default {
  props: {
    hasNext: {
      type: Boolean,
      default: true,
    },
    hasPrev: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
@import './mixins.scss';

.shop-navigation {
  display: flex;
  gap: 1rem;

  @include onPhone {
    font-size: 0.8em;
  }
}
</style>
